import moment from 'moment';

/**
 * Generuje opcje wyboru miesięcy dla roku szkolnego zaczynającego się w danym roku
 *
 * @export
 * @param {number} startYear
 * @param {('monthStart' | 'monthEnd')} [type='monthStart']
 * @returns {Array<{ value: string; text: string }>}
 */
export function generateSchoolYearMonthOptions(
  startYear: number | string,
  type: 'monthStart' | 'monthEnd' = 'monthStart'
): Array<{ value: string; text: string }> {
  const startDate = type === 'monthStart' ? moment(`${startYear}-09-01`) : moment(`${startYear}-09-30`);
  const result: Array<{ value: string; text: string }> = [];
  for (let i = 0; i < 12; i++) {
    const date = startDate.clone().add(i, 'months');
    if (type === 'monthEnd') {
      date.endOf('month');
    }
    result.push({ value: date.format('YYYY-MM-DD'), text: date.locale('pl').format('MMMM YYYY') });
  }
  return result;
}
